<template>
  <v-parallax 
    :src="getImgUrl(inspiracao)" height="500"
  >
    <div style="
      background-color: rgba(0, 0, 0, 0.50);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    "></div>
    <v-row class="align-center justify-center text-center" pb-4 style="position: relative">
      <v-col cols="12" md="8">
        <div class="display-1 white--text font-weight-regular text-xs-center">
          <span class="poppins">Quão profundamente você está disposto a mergulhar para se encontrar?</span>
        </div>
        <v-btn
          x-large
          color="white primary--text"
          class="mt-8 mx-auto"
          @click="$vuetify.goTo('#mais-info')"
        >
          <span class="font-weight-bold">Inscreva-se</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-parallax>
</template>

<script>
export default {
  data () {
    return {
      inspiracao: 'inspiracao.jpg'
    }
  },
  methods: {
    getImgUrl(i) {
      return require('../assets/img/'+i)
    },
  }
}
</script>